<template>
      <div class="div_outer_box">
        <template v-for="(video,videoKey,index) in ($route.name == 'wallet-deposit' ? walletConfig.deposit_video : walletConfig.withdrawal_video)" :key="index">
            <div class="deposit_demo_video_section" v-if="video">
                <div class="custom_container">
                    <div class="withdraws_video_sec">
                        <div class="withdraws-video-con">
                            <div class="video_thm_title">
                                <h2>{{$route.name == 'wallet-deposit' ? $t('how-to-deposit', 'How To Deposit') : $t('how-to-withdraw', 'How To Withdraw') }} ({{ videoKey }})</h2>
                            </div>
                            <iframe width="100%" height="180" :src="video" :title="videoKey"
                                frameborder="0"
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </template>
   </div>
</template>
<script>
export default {
    name: "WalletInstructionVideos",
    inject: ['walletConfig'],
}
</script>